import useFetch from "../../../_helpers/hooks/useFetch";
import { useState } from "react";
import { bdoActions } from "../../../_store/bdo.slice";

export function useKeoCardsSearch() {
  const fetch = useFetch();
  const [items, setItems] = useState([]);

  const onSearchChange = async(filters) => {
    let data = { pageNumber: 1, pageSize: 50, ...filters };
    await fetch(bdoActions.searchKeoCards({ payload: data }), setItems);
  };

  return { onSearchChange, items: items.loading ? [] : items };
}